import styled from 'styled-components'
import {COLORS} from "@app/constants";


export const HeaderButtonWrap = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
        color: ${COLORS.BTN_HOVER};
    }
    color: ${props => props.theme.COLORS.textw};
`

export const HeaderButtonInner = styled.div`
    display: flex;
    margin-left: 0.3rem;
    margin-right: 1rem;
    white-space: nowrap;
`
